import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const useFlagsForUniversalAttributes = () => {
  const enableCheckoutUpsellItems2 = useFlag(LaunchDarklyFlag.ENABLE_CHECKOUT_UPSELL_ITEMS_2);

  const enableStoreConfirmationModal = useFlag(LaunchDarklyFlag.ENABLE_STORE_CONFIRMATION_MODAL);
  const enableServiceModeCartSelection = useFlag(
    LaunchDarklyFlag.ENABLE_SERVICE_MODE_CART_SELECTION
  );
  const enableOffersRefresh = useFlag(LaunchDarklyFlag.ENABLE_OFFERS_REFRESH);
  const enableFeatureHomePage = useFlag(LaunchDarklyFlag.ENABLE_FEATURE_HOME_PAGE);
  const enableHomePageRecentItems = useFlag(LaunchDarklyFlag.ENABLE_HOME_PAGE_RECENT_ITEMS);
  const enableRecentItemsAddToCart = useFlag(LaunchDarklyFlag.ENABLE_RECENT_ITEMS_ADD_TO_CART);
  const enableRecentlyOrderedItems = useFlag(LaunchDarklyFlag.ENABLE_RECENTLY_ORDERED_ITEMS);
  const enableCognitoSignupInBE = useFlag(LaunchDarklyFlag.ENABLE_COGNITO_SIGNUP_IN_BE);
  const enableUserSavedDeliveryAddressPhone = useFlag(
    LaunchDarklyFlag.ENABLE_USER_SAVED_DELIVERY_ADDRESS_PHONE
  );
  const enableRecentItemsWithModifiers = useFlag(
    LaunchDarklyFlag.ENABLE_RECENT_ITEMS_WITH_MODIFIERS
  );

  return {
    enableRecentItemsWithModifiers,
    enableCheckoutUpsellItems2,
    enableStoreConfirmationModal,
    enableServiceModeCartSelection,
    enableOffersRefresh,
    enableFeatureHomePage,
    enableHomePageRecentItems,
    enableRecentItemsAddToCart,
    enableRecentlyOrderedItems,
    enableUserSavedDeliveryAddressPhone,
    enableCognitoSignupInBE,
  };
};
